/**
 * Represents a symbol for selecting spaces service.
 */
export const SelectSpacesService = Symbol.for('SelectSpacesService');
